import React, {
  FC, HTMLAttributes, ReactNode,
} from 'react';
import styled, { FlattenSimpleInterpolation } from 'styled-components';

import { PageTitleStyle, TextBoldStyle } from '~/atomic/Typography';
import { lessThan } from '~/lib/mediaQuery';

interface UserProfileInfoProps extends HTMLAttributes<HTMLDivElement> {
  title: string;
  items: Array<{
    count: number;
    icon: ReactNode;
    name: string;
  }>
  itemCss?: FlattenSimpleInterpolation;
}

export const UserProfileInfo: FC<UserProfileInfoProps> = ({
  title,
  items,
  itemCss,
  ...props
}) => {
  return (
    <SCUserProfileInfo {...props}>
      <SCTitle>
        {title}
      </SCTitle>
      <SCList>
        {items.map((item) => (
          <SCItem css={itemCss}>
            <SCCount>{item.count}</SCCount>
            <SCIcon>
              {item.icon}
            </SCIcon>
            <SCName>{item.name}</SCName>
          </SCItem>
        ))}
      </SCList>
    </SCUserProfileInfo>
  );
};

const SCUserProfileInfo = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 370px;
  width: 100%;
`;

const SCTitle = styled.h2`
  ${PageTitleStyle};
  margin-bottom: 24px;

  ${lessThan('sm')} {
    text-align: center;
    margin-bottom: 20px;
  }
`;

const SCList = styled.div`
  background: #FFFFFF;
  padding: 16px 24px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 100%;

  > *:not(:last-child) {
    margin-bottom: 20px;
  }

  ${lessThan('sm')} {
    padding: 12px 16px;
  }
`;

const SCItem = styled.div<{ css: FlattenSimpleInterpolation }>`
  display: flex;
  align-items: center;

  > *:not(:last-child) {
    margin-right: 12px;
  }
  
  ${(props) => props?.css}
`;

const SCIcon = styled.div`
  min-width: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SCCount = styled.span`
  font-family: var(--main-font);
  font-weight: 700;
  font-size: 18px;
  line-height: 25px;
  color: var(--black-color);
  min-width: 30px;
  text-align: right;
`;

const SCName = styled.span`
  ${TextBoldStyle};
  font-weight: 600;
  white-space: break-spaces;
  color: var(--black-color);
`;
